// Maps the `page_key` rows in the `page_visibility` admin table
// to the actual route prefixes those pages live at. Used by
// <PageVisibilityGuard /> to redirect non-admin visitors away
// from pages an admin has hidden.
//
// Use route PREFIXES — anything starting with the prefix is
// considered the same page (e.g. `/staysphere/123` is covered by
// `/staysphere`).

export const PAGE_KEY_TO_PATHS: Record<string, string[]> = {
  marketplace: ["/marketplace"],
  events: ["/events"],
  dating: ["/dating"],
  forum: ["/forum"],
  groups: ["/groups"],
  freelance: ["/freelance"],
  jobs: ["/jobs", "/job-board"],
  campus: ["/campus"],
  bible_wall: ["/bible-wall"],
  interview: ["/interview-generator"],
  resume_ai: ["/resume-ai"],
  qr_generator: ["/qr-generator"],
  digital_card: ["/digital-cards"],
  invitations: ["/invitations"],
  receipt_ledger: ["/accounting"],
  hall: ["/hall"],
  raffles: ["/raffles"],
  quiz: ["/quizverse"],
  giving: ["/giving"],
  news: ["/news"],
  trading: ["/trading"],
  forex_trading: ["/trading"],
  predictions: ["/predictions"],
  crypto: ["/buy-crypto"],
  currency_flip: ["/currency-flip"],
  escrow: ["/escrow"],
  logistics: ["/logistics"],
  skill_trades: ["/skill-trades"],
  business_directory: ["/business-directory"],
  bank_connect: ["/bank-connect"],
  legal_directory: ["/legal-directory"],
  food_delivery: ["/food-court"],
  salon_spa: ["/beauty"],
  staysphere: ["/staysphere", "/travel"],
  streaming: ["/streaming", "/engage"],
  esim_store: ["/esim-store"],
  airtime: ["/airtime"],
  gift_cards: ["/gift-cards"],
  utility_payments: ["/utility-payments"],
  qr: ["/qr-generator"],
  job_insights: ["/job-insights"],
  talent: ["/talent"],
  my_bids: ["/my-bids"],
  kyc: ["/kyc"],
  scle: ["/logistics"],
  election_raffle: ["/elections/raffle"],
  election_map: ["/elections/map"],
};

/**
 * Returns the page_key whose prefix matches the given pathname,
 * or null if the pathname is not gated by any page_visibility row.
 */
export function pageKeyForPath(pathname: string): string | null {
  for (const [key, paths] of Object.entries(PAGE_KEY_TO_PATHS)) {
    for (const p of paths) {
      if (pathname === p || pathname.startsWith(p + "/")) return key;
    }
  }
  return null;
}